export const STRATEGY = {
    SWAP: 'SWAP',
    INSERT: 'INSERT',
} as const;

export const MASTER_DESCRIPTOR_OVER_PREFIX = 'over-' as const;
